import React from 'react';

export const Delete2 = ({
  className,
  color,
  width,
  height,
}: {
  className?: string;
  color?: string;
  width?: string;
  height?: string;
}) => (
  <svg
    width={width ?? '15'}
    height={height ?? '16'}
    viewBox={height ? `0 0 ${width} ${height}` : '0 0 15 16'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.49992 3.8335V13.0002C2.49992 13.4422 2.67551 13.8661 2.98807 14.1787C3.30063 14.4912 3.72456 14.6668 4.16658 14.6668H10.8333C11.2753 14.6668 11.6992 14.4912 12.0118 14.1787C12.3243 13.8661 12.4999 13.4422 12.4999 13.0002V3.8335M4.99992 3.8335C4.99992 3.17045 5.26331 2.53457 5.73215 2.06573C6.20099 1.59689 6.83688 1.3335 7.49992 1.3335V1.3335C8.16296 1.3335 8.79884 1.59689 9.26769 2.06573C9.73653 2.53457 9.99992 3.17045 9.99992 3.8335V3.8335H4.99992ZM4.99992 3.8335H9.99992H4.99992ZM4.99992 3.8335H2.49992H4.99992ZM9.99992 3.8335H12.4999H9.99992ZM14.1666 3.8335H12.4999H14.1666ZM0.833252 3.8335H2.49992H0.833252Z"
      stroke={color || '#FF5630'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
